import { Card, Skeleton, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { FilterSkeleton } from 'entities/scenario/ui/FilterSkeleton';

import styles from './PlatformConsentAcceptanceSkeleton.module.scss';
import { RightPartSkeleton } from './RightPart';

export const CommonFDSkeleton = () => {
  const isMobile = useIsMobile();

  return (
    <Space
      direction={isMobile ? 'vertical' : undefined}
      size={32}
    >
      <Space
        size={16}
        direction="vertical"
        className={styles.leftPanel}
      >
        {isMobile ? (
          <Space
            size={12}
            justify="space-between"
          >
            <Card
              size={16}
              className={styles.width100}
            >
              <Space justify="space-between">
                <Space
                  size={2}
                  direction="column"
                >
                  <Skeleton.Paragraph
                    style={{ height: 12 }}
                    width={50}
                  />
                  <Skeleton.Paragraph
                    style={{ height: 14 }}
                    width={80}
                  />
                </Space>
              </Space>
            </Card>
            <Card
              size={16}
              className={styles.width100}
            >
              <Space justify="space-between">
                <Space
                  size={2}
                  direction="column"
                >
                  <Skeleton.Paragraph
                    style={{ height: 12 }}
                    width={50}
                  />
                  <Skeleton.Paragraph
                    style={{ height: 14 }}
                    width={80}
                  />
                </Space>

                <Skeleton.Avatar className={styles.avatar} />
              </Space>
            </Card>
          </Space>
        ) : null}

        <Card className={styles.card}>
          <Space
            size={16}
            direction="vertical"
          >
            <FilterSkeleton className={styles.filter} />

            {isMobile ? null : (
              <Space
                direction="column"
                size={16}
              >
                <Space
                  direction="column"
                  size={2}
                >
                  <Skeleton.Paragraph
                    style={{ height: 14 }}
                    width={25}
                  />
                  <Skeleton.Paragraph
                    style={{ height: 16 }}
                    width={60}
                  />
                </Space>

                <Space justify="space-between">
                  <Space
                    direction="column"
                    size={2}
                  >
                    <Skeleton.Paragraph
                      style={{ height: 14 }}
                      width={80}
                    />
                    <Skeleton.Paragraph
                      style={{ height: 16 }}
                      width={50}
                    />
                  </Space>

                  <Skeleton.Avatar className={styles.avatar} />
                </Space>
              </Space>
            )}
          </Space>
        </Card>
        {isMobile ? null : (
          <>
            <Card className={styles.bottomBlocks}>
              <Skeleton.Paragraph width={60} />
            </Card>
            <Card className={styles.bottomBlocks}>
              <Skeleton.Paragraph width={60} />
            </Card>
          </>
        )}
      </Space>

      <RightPartSkeleton />
    </Space>
  );
};
